import request from '@/utils/request'

export function getStatsDatasets () {
  return request({
    url: '/homepage/stats/datasets',
    method: 'get'
  })
}

export function getStatsProvinces () {
  return request({
    url: '/homepage/stats/provinces',
    method: 'get'
  })
}

export function getStatsCities () {
  return request({
    url: '/homepage/stats/cities',
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/homepage.js